import Papa from 'papaparse'
import React, { ChangeEvent, useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import * as XLSX from 'xlsx'
import { t } from '../locale'
import { Link } from 'react-router-dom'

interface CsvFileInputProps {
  onFileLoad: (data: any[]) => void
}

const CsvFileInput: React.FC<CsvFileInputProps> = ({ onFileLoad }) => {
  const [modal, setModal] = useState(false)

  const headerMapping: Record<string, string> = {
    Mandantennummer: 'clientNumber',
    Vorname: 'firstName',
    Name: 'name',
    Land: 'country',
    'Ist natürliche Person': 'isPerson',
    Geschlecht: 'gender',
    'E-Mail': 'email',
    Geburtsdatum: 'dateOfBirth',
    'Straße und Hausnummer': 'streetAddress',
    Postleitzahl: 'zipCode',
    Stadt: 'city',
  }

  const transformRows = (rows: any[]) =>
    rows.map((row: any) => {
      const transformedRow: Record<string, any> = {}
      for (const [field, appField] of Object.entries(headerMapping)) {
        if (field in row) {
          transformedRow[appField] = row[field]
        }
      }
      return transformedRow
    })

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const fileExtension = file.name.split('.').pop()?.toLowerCase()

    if (fileExtension === 'csv') {
      const reader = new FileReader()
      reader.onload = event => {
        const buffer = event.target?.result as ArrayBuffer
        let text: string
        try {
          text = new TextDecoder('utf-8', { fatal: true }).decode(buffer)
        } catch {
          text = new TextDecoder('windows-1252').decode(buffer)
        }
        Papa.parse(text, {
          complete: result => onFileLoad(transformRows(result.data)),
          header: true,
          dynamicTyping: true,
          skipEmptyLines: true,
        })
      }
      reader.readAsArrayBuffer(file)
    } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
      const reader = new FileReader()
      reader.onload = event => {
        const data = new Uint8Array(event.target?.result as ArrayBuffer)
        const workbook = XLSX.read(data, { type: 'array' })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        onFileLoad(transformRows(XLSX.utils.sheet_to_json(worksheet)))
      }
      reader.readAsArrayBuffer(file)
    }

    setModal(false)
  }

  return (
    <>
      <Button
        variant='none'
        className='btn btn-sm btn-outline-primary rounded-pill btn-spacing'
        onClick={() => setModal(true)}
      >
        <i className='bi bi-cloud-upload'></i>
        &nbsp;{t('importList')}
      </Button>
      <Modal className='modal' id='token' show={modal} centered>
        <Modal.Header>
          <h4 className='modal-title'>{t('excelFileExample')}</h4>
          <Button
            variant='none'
            className='btn-close'
            data-bs-dismiss='modal'
            aria-label='Close'
            onClick={() => setModal(false)}
          ></Button>
        </Modal.Header>

        <Modal.Body>
          <p>{t('thisIsExampleExcel')}</p>
          <a
            href='/csv_import.xlsx'
            download
            className='btn btn-sm btn-outline-success rounded-pill mb-3'
          >
            <i className='bi bi-download'></i> &nbsp;{t('downloadExample')}
          </a>
          <div className='col-12 mx-auto'>
            <hr className='my-4' />

            <div className='mb-3'>
              <h6 className='mb-2'>{t('excelImport')}</h6>

              <label className='btn btn-sm btn-outline-primary rounded-pill'>
                <input
                  type='file'
                  accept='.csv, .xls, .xlsx'
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
                <i className='bi bi-cloud-upload'></i>
                &nbsp;{t('importList')}
              </label>
            </div>

            <hr className='my-4' />

            <div>
              <p className='mb-2'>{t('connectWith')}:</p>

              <div className='d-flex gap-2'>
                <Link to='/company/abacus' className='btn btn-sm btn-outline-primary rounded-pill'>
                  {t('abacusIntegration')}
                </Link>

                <Link to='/company/bexio' className='btn btn-sm btn-outline-primary rounded-pill'>
                  {t('bexioIntegration')}
                </Link>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CsvFileInput
